import(/* webpackMode: "eager" */ "/vercel/path0/apps/app/src/app/[locale]/profil/[user]/not-found.tsx");
